import React from "react";
import { Outlet } from "react-router-dom";

const CustomerPrivateRoute: React.FC = () => {
    return <Outlet />;
};

export default CustomerPrivateRoute;